import moment from 'moment';
import Vue from 'vue';
import { getAll, graphQL } from '../../api';
import { getScreenStats } from '../../api/modules/screenStats';

const state = {
  details: {
    chart: {
      data: [],
      labels: [],
    },
    requests: [{ data: [0, 0, 0, 0, 0, 0] }],
    requestLabels: [
      moment()
        .subtract(5, 'month')
        .startOf('month')
        .format('MMMM'),
      moment()
        .subtract(4, 'month')
        .startOf('month')
        .format('MMMM'),
      moment()
        .subtract(3, 'month')
        .startOf('month')
        .format('MMMM'),
      moment()
        .subtract(2, 'month')
        .startOf('month')
        .format('MMMM'),
      moment()
        .subtract(1, 'month')
        .startOf('month')
        .format('MMMM'),
      moment()
        .subtract(0, 'month')
        .startOf('month')
        .format('MMMM'),
    ],
    coordinates: {
      items: [],
    },
  },
  screenUptime: 0,
  screenStatus: 'green',
  currentSession: null,
  currentRound: {},
  accessories: [],
  updatedAccessories: {},
  loading: false,
  editingDetails: false,
  deleteModal: false,
  updated: false, // controls update snackbar
  updateInProgress: false,
  cartStatus: 'Not In Use',
};

const getters = {
  getDetails(state) {
    return state.details;
  },
  getCurrentSession(state) {
    return state.currentSession;
  },
  getCurrentRound(state) {
    return state.currentRound;
  },
  getAccessories(state) {
    return state.accessories;
  },
  getScreenUptime(state) {
    return state.screenUptime;
  },
  getScreenStatus(state) {
    return state.screenStatus;
  },
  getEditingDetails(state) {
    return state.editingDetails;
  },
  getDeleteModal(state) {
    return state.deleteModal;
  },
  getUpdated(state) {
    return state.updated;
  },
  getUpdateInProgress(state) {
    return state.updateInProgress;
  },
  getCartStatus(state) {
    return state.cartStatus;
  },
};

const actions = {
  acquireDetails: async ({ commit, dispatch, rootGetters }, payload) => new Promise((resolve, reject) => {
    if (rootGetters['account/getCurrentClient'].client_name == 'shark') {
      dispatch('acquireSharkDetails', payload);
    } else {
      commit('loading/setLoading', true, { root: true });
      let callString = '{uuid, ad_schedule, beep, charged_off, area_id, group_id, store_id, debug, device_id, notify_users, phone_number, screen_uptime, session_status, status, version, trip_type, session_type, checked, pushy_token, twilio, last_activity, error, success}';
      if (rootGetters['account/getCurrentClient'].client_name == 'shark') {
        callString = '{uuid, ad_schedule, beep, charged_off, area_id, created_at, group_id, store_id, debug, device_id, notify_users, phone_number, launch_mode, imei, screen_uptime, car_number, session_status, status, version, trip_type, session_type, checked, pushy_token, twilio, last_activity, error, success}';
      }
      const clientTable = rootGetters['account/getCurrentClient'].table_name;
      getAll(
        `/screen?query=${
          encodeURIComponent(
            `{get(type_name: "screen", 
          screen: {uuid: "${payload}"}, 
          table_name:"${clientTable}", 
        )${callString}}`,
          )}`,
      )
        .then((res) => {
          dispatch('getAnalyticsData', payload);
          dispatch('getAccessoryData', payload);
          dispatch('getScreenshotData', payload);
          dispatch('getScreenCoordinateData', payload);
          if (rootGetters['account/getCurrentClient'].client_name === 'shark') {
            dispatch('getScreenRound', payload);
            commit('setCartStatus', res.data.data.get[0]);
          } else {
            dispatch('getScreenSession', payload);
          }
          dispatch('getScreenUptime', payload);
          commit('setDetails', res.data.data.get[0]);
          resolve(res);
        })
        .catch((err) => {
          commit('loading/setLoading', false, { root: true });
          reject(err);
        });
    }
  }),
  acquireSharkDetails: async (
    { commit, dispatch, rootGetters }, payload,
  ) => new Promise((resolve, reject) => {
    commit('loading/setLoading', true, { root: true });
    let callString = '{uuid, ad_schedule, beep, charged_off, area_id, group_id, store_id, debug, device_id, notify_users, phone_number, screen_uptime, session_status, status, version, trip_type, session_type, checked, pushy_token, twilio, last_activity, error, success}';
    if (rootGetters['account/getCurrentClient'].client_name === 'shark') {
      callString = '{uuid, ad_schedule, beep, charged_off, area_id, created_at, group_id, store_id, debug, device_id, notify_users, phone_number, launch_mode, imei, screen_uptime, car_number, session_status, status, version, trip_type, session_type, checked, pushy_token, twilio, last_activity,group_name, network_status, active_in_round, error, success}';
    }
    graphQL({
      query: `
            query {
              getScreen(
                uuid: "${payload}"
              ) ${callString}
            }
          `,
    })
      .then((res) => {
        dispatch('getAnalyticsData', payload);
        // dispatch("getScreenAnalyticsGraphData", payload);
        dispatch('getAccessoryData', payload);
        dispatch('getScreenshotData', payload);
        dispatch('getScreenCoordinateData', payload);
        if (rootGetters['account/getCurrentClient'].client_name === 'shark') {
          dispatch('getScreenRound', payload);
          dispatch('getSharkScreenUptime', payload);
          commit('setCartStatus', res.data.data.getScreen);
        } else {
          dispatch('getScreenSession', payload);
          dispatch('getScreenUptime', payload);
        }
        commit('setDetails', res.data.data.getScreen);
        resolve(res);
      })
      .catch((err) => {
        commit('loading/setLoading', false, { root: true });
        reject(err);
      });
  }),
  getScreenUptime: async ({ commit }, payload) => new Promise((resolve, reject) => {
    getScreenStats(payload)
      .then((response) => {
        commit('setUpTime', response.data.Items);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  }),
  getSharkScreenUptime: async ({ commit }, payload) => new Promise((resolve, reject) => {
    graphQL({
      query: `
          query {
            getScreenUpTime(
              uuid: "${payload}"
            ){
              up_time_hours
            }
          }
        `,
    })
      .then((res) => {
        commit('setSharkUpTime', res.data.data.getScreenUpTime.up_time_hours);
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  }),
  uploadDetails: async (
    {
      commit, dispatch, rootGetters, getters,
    },
    payload,
  ) => new Promise((resolve, reject) => {
    commit('setUpdateInProgress', true);

    const screen = getters.getDetails;
    let screenData = {
      uuid: screen.uuid,
    };
    if (!payload) {
      (screenData.phone = screen.phone ? screen.phone : undefined),
      (screenData.ad_schedule = screen.ad_schedule
        ? screen.ad_schedule
        : undefined),
      (screenData.charged_off = screen.unit_info[8].value
        ? screen.unit_info[8].value
        : undefined),
      (screenData.last_activity = Number(
        moment(screen.unit_info[1].value).format('X'),
      )),
      (screenData.notify_users = screen.notify_users),
      (screenData.screen_uptime = screen.screen_uptime),
      (screenData.session_status = screen.unit_info[6].value
        ? screen.unit_info[6].value.toString()
        : ''),
      (screenData.status = screen.status),
      (screenData.version = screen.version),
      (screenData.trip_type = screen.unit_info[4].value),
      (screenData.session_type = screen.session_type),
      (screenData.checked = screen.checked),
      (screenData.pushy_token = screen.pushy_token),
      (screenData.uptime = screen.uptime),
      (screenData = JSON.stringify(screenData).replace(
        /"([^"]+)":/g,
        '$1: ',
      ));
    } else {
      screenData = payload;
      screenData = JSON.stringify(screenData).replace(/"([^"]+)":/g, '$1: ');
    }
    const clientTable = rootGetters['account/getCurrentClient'].table_name;

    getAll(
      `/screen?query=${
        encodeURIComponent(
          `mutation{update(type_name: "screen", 
            screen: ${screenData}, 
            table_name:"${clientTable}", 
            index: "all-index"
          ){
            phone,
            ad_schedule,
            beep,
            charged_off,
            area_id,
            created_at,
            group_id,
            store_id,
            debug,
            device_id,
            launch_mode,
            last_activity,
            notify_users,
            screen_uptime,
            session_status,
            status,
            version,
            trip_type,
            session_type,
            checked,
            pushy_token,
            twilio,
            uptime,
            uuid, 
            error, 
            success
          }}`,
        )}`,
    )
      .then(() => {
        dispatch('acquireDetails', screen.uuid);
        commit('setUpdated', true);
        setTimeout(() => {
          commit('setUpdateInProgress', false);
        }, 400);
        resolve();
      })
      .catch((err) => {
        setTimeout(() => {
          commit('setUpdateInProgress', false);
        }, 400);
        reject(err);
      });
  }),
  updateSession: async ({ dispatch, rootGetters }, payload) => new Promise((resolve, reject) => {
    const newPayload = JSON.stringify(payload).replace(/"([^"]+)":/g, '$1: ');
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/session?query=${
        encodeURIComponent(
          `mutation{update(type_name: "session", 
            session: ${newPayload}, 
            table_name:"${clientTable}", 
          ){
            uuid,
            area_id, 
            group_id, 
            screen_id, 
            expected_end_at, 
            start_at, 
            trip_type, 
            end_at, 
            rider_email, 
            error, 
            success
          }}`,
        )}`,
    )
      .then(() => {
        if (rootGetters['account/getCurrentClient'].client_name === 'shark') {
          dispatch('getScreenRound', state.details.uuid);
        } else {
          dispatch('getScreenSession', state.details.uuid);
        }
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
  }),
  updateAccessories: async ({ commit, rootGetters }, payload) => new Promise((resolve, reject) => {
    const newPayload = JSON.stringify(payload).replace(/"([^"]+)":/g, '$1: ');
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/accessory?query=${
        encodeURIComponent(
          `mutation{update(type_name: "accessory", 
            accessory: ${newPayload}, 
            table_name:"${clientTable}", 
          ){
            uuid,
            error, 
            success
          }}`,
        )}`,
    )
      .then((res) => {
        commit('updatedAccessories', res);
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
  }),
  getAccessoryData: async ({ commit, rootGetters }, payload) => {
    payload;
    return new Promise((resolve, reject) => {
      const clientTable = rootGetters['account/getCurrentClient'].table_name;
      getAll(
        `/accessory?query=${
          encodeURIComponent(
            `{get(type_name: "accessory", 
            accessory: {screen_id: "${payload}"},  
            table_name:"${clientTable}", 
            index: "screen-index"
          ){
            uuid,
            error, 
            success
          }}`,
          )}`,
      )
        .then((res) => {
          commit('setScreenAccessoryData', {
            data: res.data.data.get,
          });
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAnalyticsData: async ({ commit, rootGetters, dispatch }, payload) => new Promise((resolve, reject) => {
    if (rootGetters['account/getCurrentClient'].client_name == 'shark') {
      dispatch('getSharkgetAnalyticsData', payload);
    } else {
      const clientTable = rootGetters['account/getCurrentClient'].table_name;
      getAll(
        `/analytic?query=${
          encodeURIComponent(
            `{get(type_name: "analytic", 
              analytic: {screen_id: "${payload}"},  
              table_name:"${clientTable}", 
              index: "screen-index"
            ){
              type,
              screen_id,
              session_id,
              description,
              duration
              created_at
            }}`,
          )}`,
      )
        .then((res) => {
          commit('setScreenAnalyticsData', {
            data: res.data.data.get,
            client: rootGetters['account/getCurrentClient'].client_name,
          });
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    }
  }),
  getSharkAnalyticsData: async ({ commit, rootGetters }, payload) => new Promise((resolve, reject) => {
    graphQL({
      query: `
            query {
              getAllAnalytics
                (filter: {screen_id: "${payload}"})
            {
            type,
            screen_id,
            session_id,
            description,
            duration
            created_at
          }
        }`,
    })
      .then((res) => {
        commit('setScreenAnalyticsData', {
          data: res.data.data.getAllAnalytics,
          client: rootGetters['account/getCurrentClient'].client_name,
        });
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  }),
  getScreenAnalyticsGraphData: async ({ commit, rootGetters }, payload) => new Promise((resolve, reject) => {
    graphQL({
      query: `
          query {
            getScreenAnalyticsGraphData(
              screen_id: "${payload}"
            ){
              chart {
                chartType
                showOnMobile
                type
                component
                width
                title
                data {
                  data
                  name
                }
                labels
                secondaryTitle
                options {
                  colors
                }
              }
              chartApp {
                chartType
                showOnMobile
                type
                component
                width
                title
                data {
                  data
                  name
                }
                labels
                secondaryTitle
                options {
                  colors
                }
              }
            }
          }
        `,
    })
      .then((res) => {
        commit('setSharkScreenAnalyticData', {
          data: res.data.data.getScreenAnalyticsGraphData,
          client: rootGetters['account/getCurrentClient'].client_name,
        });
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  }),
  getScreenshotData: async ({ commit, rootGetters }, payload) => {
    payload;
    return new Promise((resolve, reject) => {
      const clientTable = rootGetters['account/getCurrentClient'].table_name;
      getAll(
        `/screenshot?query=${
          encodeURIComponent(
            `{get(type_name: "screenshot", 
            screenshot: {screen_id: "${payload}"}, 
            table_name:"${clientTable}", 
            index: "screen-index"
          ){
            area_id,
            screen_id,
            group_id,
            url
          }}`,
          )}`,
      )
        .then((res) => {
          commit('setScreenshotData', {
            data: res.data.data.get,
          });
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getScreenCoordinateData: async ({ commit, rootGetters, dispatch }, payload) => {
    payload;
    return new Promise((resolve, reject) => {
      if (rootGetters['account/getCurrentClient'].client_name == 'shark') {
        dispatch('getSharkScreenCoordinateData', payload);
      } else {
        const clientTable = rootGetters['account/getCurrentClient'].table_name;
        getAll(
          `/coordinate?query=${
            encodeURIComponent(
              `{getPaginated(type_name: "coordinate", 
              coordinate: {screen_id: "${payload}"}, 
              table_name:"${clientTable}",  
              index: "screen-index",
              pageSize:"100"
            ){items{
              area_id, 
              group_id, 
              store_id, 
              screen_id, 
              session_id, 
              latitude, 
              longitude, 
              created_at, 
              timestamp, 
              error, 
              success
            }}}`,
            )}`,
        )
          .then((res) => {
            commit('setScreenCoordinateData', {
              data: res.data.data.getPaginated.items,
            });
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      }
    });
  },
  getSharkScreenCoordinateData: async ({ commit }, payload) => {
    payload;
    return new Promise((resolve, reject) => {
      graphQL({
        query: `
            query {
              getAllCoordinates(
                filter: {screen_id: "${payload}"}
          ){
            area_id, 
            group_id, 
            store_id, 
            screen_id, 
            session_id, 
            latitude, 
            longitude, 
            created_at, 
            timestamp, 
            error, 
            success
          }}`,
      })
        .then((res) => {
          commit('setScreenCoordinateData', {
            data: res.data.data.getAllCoordinates,
          });
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getScreenSession: async ({ commit, rootGetters }, payload) => new Promise((resolve, reject) => {
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/session?query=${
        encodeURIComponent(
          `{get(type_name: "session", 
            session: {screen_id: "${payload}"}, 
            table_name:"${clientTable}",  
            index: "screen-index"
          ){
            uuid,
            area_id, 
            group_id, 
            screen_id, 
            expected_end_at, 
            start_at, 
            trip_type, 
            end_at, 
            updated_at,
            rider_email, 
            error, 
            success
          }}`,
        )}`,
    )
      .then((res) => {
        commit('setCurrentSession', {
          data: res.data.data.get,
        });
        commit('loading/setLoading', false, { root: true });
        resolve(res);
      })
      .catch((error) => {
        commit('loading/setLoading', false, { root: true });
        reject(error);
      });
  }),
  getScreenRound: async ({ commit }, payload) => new Promise((resolve, reject) => {
    graphQL({
      query: `
            query {
              getAllRounds
                (filter: {screen_id: "${payload}"})
            {
            uuid,
            group_id, 
            screen_id, 
            imei,
            end_time,
            start_time,
            gpsi_car_number,
            course_launch_intent_mode,
            error, 
            success
          }}`,
    })
      .then((res) => {
        res.data.data.getAllRounds.sort((a, b) => b.end_time.toString().localeCompare(a.end_time.toString()));
        if (res.data.data.getAllRounds && res.data.data.getAllRounds[0]) {
          commit('setCurrentRound', res.data.data.getAllRounds[0]);
        }
        commit('loading/setLoading', false, { root: true });
        resolve(res);
      })
      .catch((error) => {
        commit('loading/setLoading', false, { root: true });
        reject(error);
      });
  }),
  deleteScreen: async ({ rootGetters }, payload) => new Promise((resolve, reject) => {
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/screen?query=${
        encodeURIComponent(
          `mutation{delete(type_name: "screen", 
            uuid: "${payload}", 
            table_name:"${clientTable}", 
          ){
            uuid
            success
            error
          }}`,
        )}`,
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        console.error('Error deleting screen: ', err);
        reject(err);
      });
  }),
};

const mutations = {
  setCurrentSession(state, payload) {
    payload.data[0].expected_end_at = moment(
      payload.data[0].expected_end_at * 1000,
    ).format('MM-DD-YYYY');
    state.currentSession = payload.data[0];
  },
  setCartStatus(state, payload) {
    const status = payload.active_in_round === 'in use' ? 'Yes' : 'No';
    state.cartStatus = status;
  },
  setCurrentRound(state, payload) {
    switch (payload.course_launch_intent_mode) {
      case 'b2b':
      case 'interface_select_bt':
        payload.course_launch_intent_mode = 'Bluetooth';
        break;
      case 'interface_select':
        payload.course_launch_intent_mode = 'Select';
        break;
      case 'interface_select_plus':
        payload.course_launch_intent_mode = 'Select+';
        break;
      case 'interface_select_plus_plus':
        payload.course_launch_intent_mode = 'Select++';
        break;
      case 'interface_prime':
        payload.course_launch_intent_mode = 'Prime';
        break;
      default:
        break;
    }
    state.currentRound = payload;
  },
  setScreenAccessoryData(state, payload) {
    state.accessories = payload.data;
  },
  setUpTime(state, payload) {
    state.screenUptime = payload[0].uptime;
    state.screenStatus = payload[0].status;
  },
  setSharkUpTime(state, payload) {
    state.screenUptime = payload;
  },
  setScreenCoordinateData(state, payload) {
    if (payload.data.length < 1) {
      state.details.coordinates.items = [
        {
          latitude: 39.719647,
          longitude: -104.957723,
          date: '2020-08-14T10:35:14-08:10',
        },
      ];
    }
    const coords = [];
    payload.data.map((coord) => {
      if (coord.created_at) {
        coords.push(coord);
      }
    });
    if (payload.data.length > 0) {
      coords.sort((a, b) => b.created_at.toString().localeCompare(a.created_at.toString()));
    }
    Vue.set(state.details.coordinates, 'items', coords);
  },
  setScreenshotData(state, payload) {
    payload.data.map((shot) => {
      shot.date = moment(shot.createdAt).format('YYYY-MM-DD');
      shot.time = moment(shot.createdAt).format('HH:mm');
    });
    Vue.set(state.details, 'screenshots', payload.data);
  },
  setScreenAnalyticsData(state, payload) {
    state.details.requests = [{ data: [0, 0, 0, 0, 0, 0] }];
    const chart = {};
    chart.chartType = 'line';
    chart.showOnMobile = null;
    chart.type = 'line-chart';
    chart.component = 'chart';
    const yAxis = [
      {
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
          color: '#008FFB',
        },
        labels: {
          style: {
            colors: '#008FFB',
          },
        },
        title: {
          text: 'Total Clicks',
          style: {
            color: '#008FFB',
          },
        },
        tooltip: {
          enabled: true,
        },
      },
      {
        seriesName: 'Average Duration (Minutes)',
        opposite: true,
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
          color: '#FFC103',
        },
        labels: {
          style: {
            colors: '#FFC103',
          },
        },
        title: {
          text: 'Average Duration (Minutes)',
          style: {
            color: '#FFC103',
          },
        },
      },
      {
        seriesName: 'Total Duration (Minutes)',
        opposite: true,
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
          color: '#00E396',
        },
        labels: {
          style: {
            colors: '#00E396',
          },
        },
        title: {
          text: 'Total Duration (Minutes)',
          style: {
            color: '#00E396',
          },
        },
      },
    ];
    chart.yAxis = yAxis;
    chart.data = [
      {
        name: 'Total Clicks',
        type: 'column',
        data: [],
      },
      {
        name: 'Average Duration (Min)',
        type: 'line',
        data: [],
      },
      {
        name: 'Total Duration (Min)',
        type: 'area',
        data: [],
      },
    ];
    chart.title = 'Feature Usage';
    chart.labels = [];
    chart.options = { colors: ['#3787B7', '#FFC103', '#C3FEE4'] };
    const chartApp = {};
    chartApp.chartType = 'line';
    chartApp.showOnMobile = null;
    chartApp.type = 'line-chart';
    chartApp.component = 'chart';
    chartApp.yAxis = JSON.parse(JSON.stringify(yAxis));
    chartApp.yAxis[0].labels.style.colors = '#000000';
    chartApp.yAxis[0].title.style.color = '#000000';
    chartApp.yAxis[0].axisBorder.color = '#000000';
    chartApp.data = [
      {
        name: 'Total Clicks',
        type: 'column',
        data: [],
      },
      {
        name: 'Average Duration (Min)',
        type: 'line',
        data: [],
      },
      {
        name: 'Total Duration (Min)',
        type: 'area',
        data: [],
      },
    ];
    chartApp.title = payload.client === 'shark' ? 'Content Sources' : 'App Usage';
    chartApp.labels = [];
    chartApp.options = { colors: ['#000000', '#FFC103', '#C3FEE4'] };
    const appLabels = [];
    const appData = {};
    const featureLabels = [];
    const featureData = {};
    const newFeatureLabels = [];
    const newAppLabels = [];
    payload.data.map((item) => {
      if (item.type == 'request' || item.type == 'feature') {
        const newDate = new Date(item.created_at);
        const check = moment.unix(newDate);
        const month = check.format('MMMM');
        const year = check.format('YYYY');
        const currentYear = moment().format('YYYY');
        if (currentYear === year) {
          const index = state.details.requestLabels.indexOf(month);
          if (index > -1) {
            state.details.requests[0].data[index] = state.details.requests[0].data[index] + 1;
          }
        }
      }
      if (item.type == 'app' || item.type == 'watch' || item.type == 'listen') {
        if (appLabels.indexOf(item.description) < 0) {
          appLabels.push(item.description);
          appData[item.description] = {
            clicks: 1,
            dur: item.duration,
          };
        } else if (appLabels.indexOf(item.description) > -1) {
          appData[item.description].clicks = appData[item.description].clicks + 1;
          appData[item.description].dur = appData[item.description].dur + item.duration;
        }
      }
      if (
        item.type == 'feature'
        && !item.description.includes('navigate')
        && !item.description.includes('click')
        && !item.description.includes('select')
        && !item.description.includes('connect')
      ) {
        if (featureLabels.indexOf(item.description) < 0) {
          featureLabels.push(item.description);
          featureData[item.description] = {
            clicks: 1,
            dur: item.duration,
          };
        } else if (featureLabels.indexOf(item.description) > -1) {
          featureData[item.description].clicks = featureData[item.description].clicks + 1;
          featureData[item.description].dur = featureData[item.description].dur + item.duration;
        }
      }
    });
    appLabels.map((label, index) => {
      appLabels[index] = { label, clicks: appData[label].clicks };
    });
    featureLabels.map((label, index) => {
      featureLabels[index] = {
        label,
        clicks: featureData[label].clicks,
      };
    });
    appLabels.sort((a, b) => (a.clicks < b.clicks ? 1 : -1));
    featureLabels.sort((a, b) => (a.clicks < b.clicks ? 1 : -1));
    appLabels.map((label, index) => {
      chartApp.data[0].data[index] = appData[label.label].clicks;
      chartApp.data[2].data[index] = Math.round(appData[label.label].dur / 60);
      chartApp.data[1].data[index] = Math.round(
        appData[label.label].dur / appData[label.label].clicks / 60,
      );
      label = label.label
        .split('_')
        .join(' ')
        .substring(0, 20);
      newAppLabels.push(label);
    });
    featureLabels.map((label, index) => {
      chart.data[0].data[index] = featureData[label.label].clicks;
      chart.data[2].data[index] = Math.round(featureData[label.label].dur / 60);
      chart.data[1].data[index] = Math.round(
        featureData[label.label].dur / featureData[label.label].clicks / 60,
      );
      label = label.label
        .split('_')
        .join(' ')
        .substring(0, 20);
      newFeatureLabels.push(label);
    });
    for (let i = 0; i < newAppLabels.length; i++) {
      if (newAppLabels[i].includes('chive')) {
        newAppLabels[i] = newAppLabels[i]
          .replace('chive', 'atmosphere')
          .split('_')
          .join(' ')
          .substring(0, 20);
      }
    }
    for (let i = 0; i < newFeatureLabels.length; i++) {
      if (newFeatureLabels[i].includes('chive')) {
        newFeatureLabels[i] = newFeatureLabels[i]
          .replace('chive', 'atmosphere')
          .split('_')
          .join(' ')
          .substring(0, 20);
      }
    }
    chartApp.labels = newAppLabels;
    chart.labels = newFeatureLabels;
    Vue.set(state.details, 'features', chart);
    Vue.set(state.details, 'appUsageData', chartApp);
  },
  setSharkScreenAnalyticData(state, payload) {
    Vue.set(state.details, 'features', payload.data.chart);
    Vue.set(state.details, 'appUsageData', payload.data.chartApp);
  },
  setDetails(state, payload) {
    let destination = null;
    let rental_status = null;
    if (!payload.destination) {
      destination = payload.group_id;
    } else {
      destination = payload.destination.name;
    }
    if (payload.launch_mode) {
      switch (payload.launch_mode) {
        case 'b2b':
        case 'interface_select_bt':
          payload.launch_mode = 'Bluetooth';
          break;
        case 'interface_select':
          payload.launch_mode = 'Select';
          break;
        case 'interface_select_plus':
          payload.launch_mode = 'Select+';
          break;
        case 'interface_select_plus_plus':
          payload.launch_mode = 'Select++';
          break;
        case 'interface_prime':
          payload.launch_mode = 'Prime';
          break;
        default:
          break;
      }
    }
    rental_status = payload.session_status;
    const last_act = payload.last_activity;
    const createdAt = payload.created_at;
    const genInfo = [
      {
        name: 'Version',
        value: payload.version,
      },
      {
        name: 'Last Activity',
        value: moment(Number(last_act) * 1000).format('MM-DD-YYYY h:mm:ss'),
      },
      {
        name: 'Phone Number',
        value: payload.phone,
      },
      {
        name: 'Twilio Number',
        value: payload.twilio,
      },
      {
        name: 'Current Trip Type',
        value: payload.trip_type,
      },
      { name: 'Car Number', value: payload.device_id },
      {
        name: 'Current Destination',
        value: destination,
      },
      {
        name: 'Rental Status',
        value: rental_status,
      },
      {
        name: 'Created Date',
        value: moment(createdAt * 1000).format('MM-DD-YYYY h:mm:ss'),
      },
      {
        name: 'Charged Off',
        value: payload.charged_off,
      },
    ];
    const month = 2628288;
    let uptime = null;
    if (payload.screen_uptime) {
      uptime = Math.round((payload.screen_uptime / month) * 100);
    } else {
      uptime = 0;
    }
    payload.chart = {
      data: [uptime],
      labels: ['Uptime'],
    };
    payload.adCampaigns = [
      {
        group: { name: 'Campaign', value: 'AVIS JFK' },
        name: { name: 'Name', value: 'Ad Manager' },
        description: { name: 'Description', value: 'Sponsored Ad' },
        duration: { name: 'Duration', value: '5 sec' },
        impressions: { name: '30 Day Impression', value: '30' },
        geo: { name: 'GEO Ad', value: null },
      },
      {
        group: { name: 'Campaign', value: 'AVIS JFK' },
        name: { name: 'Name', value: 'Ad Manager' },
        description: { name: 'Description', value: 'Sponsored Ad' },
        duration: { name: 'Duration', value: '5 sec' },
        impressions: { name: '30 Day Impression', value: '30' },
        geo: { name: 'GEO Ad', value: null },
      },
    ];
    const rawData = [];
    const keys = Object.keys(payload);
    keys.map((key) => {
      if (
        typeof payload[key] !== 'object'
        && typeof payload[key].constructor !== Array
      ) {
        const rawObject = {
          name: key,
          value: payload[key],
        };
        rawData.push(rawObject);
      }
    });
    payload.rawData = rawData;
    payload.unit_info = genInfo;
    Object.keys(payload).map((key) => {
      Vue.set(state.details, key, payload[key]);
    });
  },
  updatedAccessories(state, payload) {
    state.updatedAccessories = payload;
  },
  setEditingDetails(state, payload) {
    state.editingDetails = payload;
  },
  setDeleteModal(state, payload) {
    state.deleteModal = payload;
  },
  setUpdated(state, payload) {
    state.updated = payload;
  },
  setUpdateInProgress(state, payload) {
    state.updateInProgress = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
